export const GET_ALL_PRODUCT = `query GetProduct($input: TproductWhereInput, $skip: Float, $take: Float){
    getProduct(where: $input,skip: $skip, take: $take) {
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
      items{
        id
        name
        age
        collection
        commodityLine
        mrpId
        mrpName
        unit
        typeId
        urlImage
        urlImage1
        urlImage2
        urlImage3
        urlImage4
        urlImage5
        ttype{
            id
            name
            note
            status
        }
        plantId
        createDate
        createId
        modifyId
        modifyDate
      }
  }
}`;

export const GET_ALL_PRODUCT_SLOC = `query GetProduct($input: TproductWhereInput, $skip: Float, $take: Float){
    getProduct(where: $input,skip: $skip, take: $take) {
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
      items{
        id
        name
        age
        collection
        commodityLine
        mrpId
        mrpName
        unit
        type
        urlImage
        urlImage1
        urlImage2
        urlImage3
        urlImage4
        urlImage5
        ttype{
            id
            name
            note
            status
        }
        tstorageLocation{
            id
            sloc
            processPrice
            totalInventory
            goldenRatioThread
            itemRatioThread
            itemRatioGram
            batch
            unitPrice
            totalPrice
            unitPriceByGram
        }
        plantId
        createDate
        createId
        modifyId
        modifyDate
      }
  }
}`;

export const GET_PRODUCT_BY_FILTER = `query GetProductList($input:GetProductListInput!,$skip:Float,$take:Float){
    getProductList(where:$input,skip:$skip,take:$take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            sloc
            totalInventory
            productId
            plantId
            batch
            itemWeightGram
            itemWeightThread
            goldenWeightThread
            unitPriceByGram
            unitPriceByInch
            mcGroup
            groupPrice
            processPrice
            totalPrice
            modifyDate
            modifyName
            createDate
            createName
            tproducts{
            id
            name
            age
            collection
            commodityLine
            mrpId
            mrpName
            unit
            type
            textScan
            urlImage
            urlImage1
            urlImage2
            urlImage3
            urlImage4
            urlImage5
            ttype{
                id
                name
                note
                status
            }
            }
            
        }
    }
}`;

export const GetListBatchComboboxQuery = `
query GetListBatchCombobox($input:TstorageLocationWhereInput, $skip: Float, $take: Float){
    getStorageLocation(where:$input,groupBy:[batch], skip: $skip, take:$take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            batch
        }
    }
}
`;

export const GetListSlocCbxQuery = `query GetListSlocCombobox($input:TstorageLocationWhereInput,$skip:Float,$take:Float){
    getStorageLocation(where:$input,groupBy:[sloc],skip:$skip,take:$take){
         pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            sloc
        }
    }
}`;

export const GetListAgeCbx = `
query GetListAgeComboBoxProduct($input:TproductWhereInput,$skip:Float,$take:Float){
    getProduct(where:$input,groupBy:[age],skip:$skip,take:$take){
         pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            age
        }
    }
}`;

export const GetListCMDCbx = `query GetListAgeComboBoxProduct($input:TproductWhereInput,$skip:Float,$take:Float){
    getProduct(where:$input,groupBy:[commodityLine],skip:$skip,take:$take){
        items{
            commodityLine
        }
    }
}`;
